module.exports = __webpack_public_path__ + "img/customer_code.0cbf9647.png";